const interfacePhrases = {
    rate_limited: 'Ratenbegrenzung',
    limit_exceeded: 'Limit überschritten',
    used: 'Verwendung',
    identifier: 'Kennung',
    verification: 'Verifizierung',
    messages: 'Nachrichten',
    data: 'Daten',
    custom: 'Benutzerdefiniert',
    management_api: '{{product}}-Verwaltungs-API',
    management_api_role_description: 'Diese integrierte Rolle gewährt Zugriff auf die Verwaltungs-API.',
    client_credentials: 'Client-Anmeldedaten',
    authentication_request: 'Authentifizierungsanfrage',
    callback: 'Authentifizierungsrückruf',
    help_title: 'iden-Hilfezentrum',
    help_subtitle: 'Hilfe, ohne den Arbeitsbereich zu verlassen',
    open_help: 'Vollständige Hilfeseite öffnen',
    close_help: 'Hilfe schließen',
    about: 'Über uns und Open Source',
    open_navigation: 'Navigation öffnen',
    close_navigation: 'Navigation schließen',
    development_enabled: 'Entwicklungsfunktionen aktiviert',
    beta: 'Beta',
    impersonation: 'Identitätsübernahme',
    key: 'Schlüssel',
    value: 'Wert',
    error: 'Fehler',
    details: 'Technische Details',
    callback_failed: 'Die Anmelderückleitung konnte nicht abgeschlossen werden.',
    back_sign_in: 'Zurück zur Anmeldung',
    powered_by: 'Bereitgestellt von',
    avatar: 'Avatar',
    logo: 'Logo',
    qr_code: 'QR-Code',
    sample_title: 'Möchten Sie ein Beispiel sehen?',
    sample_description: 'Entdecken Sie eine Beispielanwendung zu dieser Anleitung.',
    sample_action: 'Beispiel anzeigen',
    further_readings: 'Weiterführende Informationen',
    complete_guide: 'Vollständige Anleitung',
    custom_domains_notice: 'Nach dem Hinzufügen <a>eigener Domains</a> können Sie diesen Endpunkt verwenden: <code>{{endpoint}}</code>.',
    my_project: 'Mein Projekt',
    my_secret: 'Mein Geheimnis',
    my_token: 'Mein Token',
    role_example: 'Betrachter',
    reset_retry: 'Konfiguration zurücksetzen und erneut versuchen',
    open_dev_panel: 'Entwicklerbereich öffnen',
    close_dev_panel: 'Entwicklerbereich schließen',
    configuration: 'Konfiguration',
    app_id: 'Anwendungs-ID',
    extra_parameters: 'Zusätzliche Anmeldeparameter',
    prompt: 'Authentifizierungsaufforderung',
    scope: 'Berechtigungsumfang',
    resource: 'Ressource',
    resources_space_delimited: 'Ressourcen (durch Leerzeichen getrennt)',
    sign_out_to_apply: 'Melden Sie sich ab, um Änderungen anzuwenden.',
    refresh_token_grant: 'Autorisierung per Aktualisierungstoken',
    organization_id: 'Organisations-ID',
    console_result: 'Das Ergebnis finden Sie in der Browserkonsole.',
    request_token: 'Token anfordern',
    user_info: 'Benutzerinformationen',
    get_id_token_claims: 'ID-Token-Claims abrufen',
    fetch_user_info: 'Benutzerinformationen abrufen',
    device_initializing: 'Geräteautorisierung wird initialisiert…',
    device_success: 'Sie haben sich erfolgreich bei der Demo angemeldet.',
    sign_in_information: 'Ihre Anmeldeinformationen:',
    email: 'E-Mail',
    username: 'Benutzername',
    user_id: 'Benutzer-ID',
    sign_out_demo: 'Von der Demo abmelden',
    device_expired: 'Gerätecode abgelaufen',
    generic_error: 'Ein Fehler ist aufgetreten',
    device_expired_description: 'Der Gerätecode ist abgelaufen. Versuchen Sie es erneut, um einen neuen Code zu erhalten.',
    sign_in_title: 'Bei Ihrem Konto anmelden',
    scan_instruction: 'Scannen Sie den QR-Code oder öffnen Sie diese Adresse auf einem anderen Gerät:',
    one_time_code: 'Einmalcode eingeben',
    token_info: 'Tokeninformationen',
    get_access_token: 'Zugriffstoken abrufen',
    context_unavailable: 'Kontoinformationen konnten nicht geladen werden.',
    not_initialized: 'Kontoinformationen sind noch nicht initialisiert.',
    not_set: 'Nicht festgelegt',
    configured: 'Konfiguriert',
    password: 'Passwort',
    phone: 'Telefonnummer',
    search_help: 'Hilfe durchsuchen',
    language: 'Sprache',
    menu: 'Menü',
    compatibility_notice: 'Kompatibilitätshinweis: Übernommene Logto-SDK-, Paket-, Protokoll-, Komponenten- und Anfrageheader-Namen bleiben unverändert.',
    source: 'Quelle',
    upstream_repository: 'Ursprüngliches Repository',
    current_fork: 'Aktuelles Repository',
    license_notice: 'iden basiert auf Logto, einer Open-Source-Software unter der Mozilla Public License 2.0.',
    about_description: 'Produktinformationen und Open-Source-Hinweise.',
    page_not_found: 'Seite nicht gefunden',
    page_not_found_description: 'Diese Seite ist nicht verfügbar. Kehren Sie zum Hilfezentrum zurück.',
    introduction: 'Einführung',
    quick_starts: 'Schnellstart',
    integration: 'Integration',
    end_user_flows: 'Endbenutzerabläufe',
    authorization: 'Autorisierung',
    user_management: 'Benutzerverwaltung',
    security: 'Sicherheit',
    customization: 'Anpassung',
    connectors: 'Konnektoren',
    organizations: 'Organisationen',
    self_hosting: 'Selbsthosting',
    continue: 'Weiter',
    loading: 'Wird geladen…',
    save: 'Speichern',
    saved: 'Gespeichert',
    try_again: 'Erneut versuchen',
    client_id: 'Client-ID',
    client_secret: 'Client-Geheimnis',
    redirect_uri: 'Weiterleitungs-URI',
    status: 'Status',
    type: 'Typ',
    permissions: 'Berechtigungen',
    token_data: 'Tokendaten',
    context_data: 'Kontextdaten',
    jwt_extra_claims: 'Zusätzliche Token-Claims',
    action_result: 'Aktionsergebnis',
    social_account_already_linked: 'Dieses Social-Media-Konto ist bereits verknüpft.',
};
export default Object.freeze(interfacePhrases);
